import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";

import { MediaObject } from "../basic/media-object-list.js"
import { SectionName } from "../basic/section-name.js";

import { DfpAd } from "../dfp-ad";

function FullscreenStoryList(props) {
  if(props.stories.length < 1)
    return <div></div>;

  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5,3]
  }
  const collectionName = get(props.associatedMetadata, ["show_collection_title"], true);

  return <div className="fullscreen-media-list">
    <div className="fullscreen-media-list__content component-wrapper">
      {collectionName ? <SectionName className="fullscreen-media-list__section-name" hideLink={true} name={props.config['collection-name']} type="large" section={props.config['collection-section']}/> : null}
      <div className="fullscreen-media-list__stories">
        {props.stories.map(storyObj => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return <div className="fullscreen-media-list__object" key={story.id}>
              <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config['collection-color']}/>
            </div>
          }
        )}

        { (props.associatedMetadata ? props.associatedMetadata.enable_load_more_button === true : true) && !props.noMoreStories && <div className="fullscreen-media-list__load-more">
          <a onClick={props.onLoadMore}>Load more</a>
        </div> }

      </div>
      <div className="ad-container">
        <div className="app-ad app-ad--vertical">
          <DfpAd adtype="Vertical-Ad"/>
        </div>
      </div>
    </div>
  </div>
}

export { FullscreenStoryList };
